import React from "react";
import { DecoratorsActions, DecoratorsStore } from "stores/decorators/DecoratorsStore";
import connect from "stores/connect";
import { Spinner } from "components/common";
import AddDecoratorButton from "./AddDecoratorButton";
import DecoratorSummary from "./DecoratorSummary";
import DecoratorList from "./DecoratorList";
import DecoratorStyles from "./decoratorStyles.css";
class DecoratorSidebar extends React.Component {
  constructor() {
    super(...arguments);
    this._formatDecorator = (decorator) => {
      const { decorators, decoratorTypes, onChange } = this.props;
      const typeDefinition = decoratorTypes[decorator.type] || {
        requested_configuration: {},
        name: `Unknown type: ${decorator.type}`
      };
      const deleteDecorator = (decoratorId) => onChange(decorators.filter((_decorator) => _decorator.id !== decoratorId));
      const updateDecorator = (id, updatedDecorator) => onChange(decorators.map((_decorator) => _decorator.id === id ? updatedDecorator : _decorator));
      return {
        id: decorator.id,
        title: /* @__PURE__ */ React.createElement(
          DecoratorSummary,
          {
            key: `decorator-${decorator.id}`,
            decorator,
            decoratorTypes,
            onDelete: deleteDecorator,
            onUpdate: updateDecorator,
            typeDefinition
          }
        )
      };
    };
    this._updateOrder = (orderedDecorators) => {
      const { decorators, onChange } = this.props;
      orderedDecorators.forEach((item, idx) => {
        const decorator = decorators.find((i) => i.id === item.id);
        decorator.order = idx;
      });
      onChange(decorators);
    };
  }
  componentDidMount() {
    DecoratorsActions.available();
  }
  render() {
    const { decoratorTypes, onChange, decorators } = this.props;
    if (!decoratorTypes) {
      return /* @__PURE__ */ React.createElement(Spinner, null);
    }
    const sortedDecorators = decorators.sort((d1, d2) => d1.order - d2.order);
    const nextDecoratorOrder = sortedDecorators.length > 0 ? sortedDecorators[sortedDecorators.length - 1].order + 1 : 0;
    const decoratorItems = sortedDecorators.map(this._formatDecorator);
    const addDecorator = (decorator) => onChange([...decorators, decorator]);
    return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(AddDecoratorButton, { decoratorTypes, nextOrder: nextDecoratorOrder, onCreate: addDecorator }), /* @__PURE__ */ React.createElement("div", { className: DecoratorStyles.decoratorListContainer }, /* @__PURE__ */ React.createElement(DecoratorList, { decorators: decoratorItems, onReorder: this._updateOrder })));
  }
}
export default connect(
  DecoratorSidebar,
  { decoratorStore: DecoratorsStore },
  ({ decoratorStore: { types = {} } = {} }) => ({ decoratorTypes: types })
);
